var _metadata, _rect, _path, _rect2, _circle, _path2, _path3, _g, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputerError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 452.06 389",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Gedankenblasen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null, "Gedankenblasen"), /*#__PURE__*/React.createElement("ccLicense", {
    rdfResource: "http://creativecommons.org/licenses/by-sa/4.0/"
  }), /*#__PURE__*/React.createElement("dcCreator", null, /*#__PURE__*/React.createElement("ccAgent", null, /*#__PURE__*/React.createElement("dcTitle", null, "Martin Wudenka")))), /*#__PURE__*/React.createElement("ccLicense", {
    rdfAbout: "http://creativecommons.org/licenses/by-sa/4.0/"
  }, /*#__PURE__*/React.createElement("ccPermits", {
    rdfResource: "http://creativecommons.org/ns#Reproduction"
  }), /*#__PURE__*/React.createElement("ccPermits", {
    rdfResource: "http://creativecommons.org/ns#Distribution"
  }), /*#__PURE__*/React.createElement("ccRequires", {
    rdfResource: "http://creativecommons.org/ns#Notice"
  }), /*#__PURE__*/React.createElement("ccRequires", {
    rdfResource: "http://creativecommons.org/ns#Attribution"
  }), /*#__PURE__*/React.createElement("ccPermits", {
    rdfResource: "http://creativecommons.org/ns#DerivativeWorks"
  }), /*#__PURE__*/React.createElement("ccRequires", {
    rdfResource: "http://creativecommons.org/ns#ShareAlike"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-107.94 301)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: -301,
    width: 400,
    height: 225,
    ry: 10.227,
    fill: "#101010",
    fillRule: "evenodd"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m560-76v10c0 5.54-4.46 10-10 10h-380c-5.54 0-10-4.46-10-10v-10z",
    fill: "#999",
    fillRule: "evenodd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: -291,
    width: 380,
    height: 205,
    ry: 0,
    fill: "#202020",
    fillRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    transform: "translate(-27.5,-588.5)",
    cx: 387.5,
    cy: 292.5,
    r: 2.5,
    fill: "#202037",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.837 0 0 1.837 29.336 929.09)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.5256 0 0 .5256 59.112 -655.56)",
    d: "m334.64 180.42h-209.28l104.64-181.25z",
    fill: "#fcdb00",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.38225 0 0 .38225 92.081 -638.29)",
    d: "m334.64 180.42h-209.28l104.64-181.25z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("text", {
    x: 171.98242,
    y: -581,
    fill: "#000000",
    fontFamily: "sans-serif",
    letterSpacing: "0px",
    wordSpacing: "0px",
    style: {
      lineHeight: "0%"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 171.98242,
    y: -581,
    fontFamily: "sans-serif",
    fontSize: "40px",
    style: {
      lineHeight: 1.25
    }
  }, "!"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1.0834 -1.9 5.6723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m231.4-101.82c-2.2535-6.1369-4.5237-3.3964-4.3852 0.19531 0.12814 3.3243 5.0869 8.3984 5.0869 8.3984s0.33933-5.7589-0.70164-8.5938z",
    fill: "#d4632a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.31-101.96c2.2535-6.1369 4.5237-3.3964 4.3852 0.19531-0.12814 3.3243-5.0869 8.3984-5.0869 8.3984s-0.33933-5.7589 0.70164-8.5937z",
    fill: "#d4632a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(5,-656)",
    cx: 260,
    cy: 560,
    rx: 20,
    ry: 10,
    fill: "#d4632a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.23-109.86c3.859-23.775 21.349-27.715 34.25-28.139s29.888 5.4548 31.704 29.043l-0.64 2.8404-1.0525 6.4453-15.787 7.6172c-11.678-7.6531-17.351-10.027-28.416 0.58594l-16.664-7.0312-2.4557-7.6172-0.70164-1.709",
    fill: "#692f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.15 77.82-12.517-119.25-8.3072-11.437-63.832-3.6475c-16.022-0.91554-24.021-28.82 3.27-30.159l61.24-3.0051 42.998-10.17s17.748 10.33 31.243 9.3876c14.426-1.0071 29.299-10.169 29.299-10.169l33.757 11.765 72.227 2.0105c17.512 0.48747 26.794 30.992-2.8316 30.775l-61.748 4.4409-8.4234 9.9097-6.392 118.94z",
    fill: "#499d89"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,-656)",
    d: "m170 750-10-120h200l-10 120h-20l10-100h-20l-10 100h-20v-100h-20v100h-20v-100h-20v100h-20l-10-100h-20l10 100z",
    fill: "#623300"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerError);
export default __webpack_public_path__ + "static/media/computer_error.2c2999a35b4042ed7fd5b44d546c79cc.svg";
export { ForwardRef as ReactComponent };